<template>
  <b-card title="لیست کاربران گروه">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <div class="mr-auto mb-1 ml-1">
                <b-button
                    variant="primary"
                    class="mr-1"
                    :disabled="!filterOptions.MessageGroupId"
                    @click="showModal = true"
                >
                  افزودن کاربر جدید
                </b-button>
                <b-button
                    variant="danger"
                    :disabled="!selected.length"
                    @click="remove()"
                >
                  حذف دسته جمعی
                </b-button>
              </div>

              <b-col md="4">
                <b-form-group
                    label="گروه چت"
                    label-for="MessageGroupId"
                >
                  <dynamic-select
                      v-model="filterOptions.MessageGroupId"
                      :url="$api.messenger.messageGroupAll"
                      :clearable="false"
                      label="Name"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>
        <b-table
            ref="table"
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            selectable
            select-mode="multi"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
            @row-selected="onRowSelected"
        >
          <template #cell(check)="data">
            <b-form-checkbox :value="data.item.UserId" @change="selectItem($event, data.item.UserId)" />
          </template>

          <template #cell(FullName)="data">
            <span class="text-nowrap">
              <b-avatar
                  class="mr-1"
                  :src="data.item.Avatar"
              />
              {{ data.item.FullName }}
            </span>
          </template>

          <template #cell(UserRole)="data">
            <b-badge
                :variant="enums('msgGroupUserRole', 'value', data.value, 'badge')"
            >
              {{ enums('msgGroupUserRole', 'value', data.item.UserRole, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.UserId)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <message-group-user-form
        :show.sync="showModal"
        :message-group-id="filterOptions.MessageGroupId"
        @done="update"
    />
  </b-card>
</template>

<script>
import DynamicSelect from "@/tools/dynamicSelect.vue";
import MessageGroupUserForm from "./messageGroupUserForm.vue";

export default {
  name: 'messageGroupUsers',
  components: { DynamicSelect, MessageGroupUserForm },
  data() {
    return {
      loading: false,
      removeLoading: false,
      filterOptions: {
        MessageGroupId: '',
        Page: 1,
        PerPage: 10,
      },
      fields: [
        {
          key: 'check',
          label: '',
          thClass: 'col-width-50',
        },
        {
          key: 'UserId',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'FullName',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'UserRole',
          label: 'نقش',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      selected: [],
      showModal: false,
      editingItem: null
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(this.$api.messenger.messageGroupUserList, { params: this.filterOptions })
          .then(res => {
            this.items = res.data.map(item => {
              return {
                ...item,
                FullName: `${item.Name} ${item.Family}`
              }
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      let data = {
        MessageGroupId: this.filterOptions.MessageGroupId,
        UserId: id ? [id] : this.selected
      }
      this.$bvModal.msgBoxConfirm(
          `آیا مطمئن هستید می خواهید این ${id ? 'کاربر' : 'کاربران'} را حذف کنید؟`,
          {
            title: this.$t('common.delete'),
            size: 'sm',
            okVariant: 'danger',
            okTitle: this.$t('common.confirm'),
            cancelTitle: this.$t('common.cancel'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
            modalClass: 'modal-danger modal-remove-confirm',
          }).then(confirm => {
            if (confirm) {
              this.removeLoading = true
              this.$http.post(this.$api.messenger.removeMessageGroupUser, data)
                  .then(() => {
                    this.removeLoading = false
                    this.update()
                  }).finally(() => {
                this.removeLoading = false
              })
            }
          })
    },
    onRowSelected(items) {
      this.selected = items.map(item => item.UserId)
    },
    selectItem(e, userId) {
      let index = this.items.findIndex(item => item.UserId === userId)
      if (e) this.$refs.table.selectRow(index)
      else this.$refs.table.unselectRow(index)
    }
  },
}
</script>
